/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'smoking_rooms': {
    width: 16,
    height: 16,
    viewBox: '0 0 20 17',
    data: '<path pid="0" d="M0 14h15v3H0zm18.5 0H20v3h-1.5zM16 14h1.5v3H16zm.85-8.27a3.324 3.324 0 0 0 1-2.38A3.35 3.35 0 0 0 14.5 0v1.5a1.852 1.852 0 0 1 1.85 1.85A1.852 1.852 0 0 1 14.5 5.2v1.5a4.021 4.021 0 0 1 4 4.07V13H20v-2.24a5.554 5.554 0 0 0-3.15-5.03zM14.03 8.2H12.5a1.986 1.986 0 0 1-1.85-2 1.769 1.769 0 0 1 1.85-1.75v-1.5A3.35 3.35 0 0 0 9.15 6.3a3.35 3.35 0 0 0 3.35 3.35h1.53A1.927 1.927 0 0 1 16 11.7V13h1.5v-1.64a3.312 3.312 0 0 0-3.47-3.16z"/>'
  }
})
